<template>
  <div class="progress-bar">
    <div
      class="progress-fill"
      :style="{
        width: `${percentage * 100}%`,
        background: fillColor,
      }"
    />
  </div>
</template>

<script>
export default {
  name: 'Progress',
  props: {
    percentage: {
      type: Number,
      default: 0.3,
      validator(value) {
        return value >= 0 && value <= 1;
      },
    },
    fillColor: {
      type: String,
      default: '#FF0000',
    },
  },
};
</script>

<style lang="less" scoped>
.progress-bar {
  width: 100%;
  height: 21px;
  background: #FFFFFF;
  border-radius: 14px;
  position: relative;
  overflow: hidden;
  
  .progress-fill {
    height: 100%;
    border-radius: 14px;
    transition: width 0.3s ease;
  }
}
</style>
